import { Component, OnInit } from '@angular/core';
declare var $: any;
declare var jquery: any;
import { GridOptions } from "ag-grid/main";
import { AdminService } from 'app/services/admin/AdminService';
import { CoachService } from 'app/services/coach/CoachService';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'app/globals';
import { TranslateService } from '@ngx-translate/core';
//import { Translation } from 'app/services/angular/Translation';


@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
    styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent implements OnInit {

    data: string[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;
    loading: boolean = false;

    announcementId: number = 0;

    headers = {
        ANNOUNCEMENTS: {
            en: "Announcements",
            fr: "Announces"
        }
    };

    expiresOnDate: Date = this.getTodayDate2();
    settings = {
        bigBanner: false,
        timePicker: false,
        format: 'MM-dd-yyyy',
        defaultOpen: false
    };
    checkboxStatus: boolean = true;   
    creating: boolean = false;
    deleting: boolean = false;

    constructor(
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _Globals: Globals,
        private _toastr: ToastrService,
        public translate: TranslateService
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

        //this.getCoachDashboardInfo();
        this.getAdminAnnouncements();

        //this.getTranslation();
    }

    public getTodayDate2() {
        var today: any = new Date();
        var dd: any = today.getDate();

        var mm: any = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        today = yyyy + '-' + mm + '-' + dd;
/*        console.log(today);*/

        return today;
    }

    private getDate(date) {
        var dd: any = date.getDate();

        var mm: any = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        date = yyyy + '-' + mm + '-' + dd;
        console.log(date);

        return date;
    }

    onDateSelect(date) {

        date = new Date(date + 'T00:00:00');

        date.setHours(0, 0, 0, 0);
        console.log('onDateSelect', date);

        let today: Date = new Date();
        today.setHours(0, 0, 0, 0);

        if (date < today) {
            this._toastr.warning("Expiration date must be greater or equal than the current date.", "ELI");
            this.expiresOnDate = this.getTodayDate2();
        }
        //else {
        //    setTimeout(() => {
        //        this.expiredOn = $('.wc-date-container span').text();
        //        console.log('expiredOn', this.expiredOn);
        //    }, 100);
        //}
    }

    changeStatus() {
        this.checkboxStatus = !this.checkboxStatus;
        console.log(this.checkboxStatus);
    }

    //getTranslation() {
    //    this._Translation.getJSON().subscribe((data: any) => {
    //        console.log("getTranslation", data);
    //    });

    //    console.log(this._Translation.getJsonTranslate('ANNOUNCEMENTS', 'BTN_TEXT').then((data: any) => {
    //        //... continue with anything depending on "data" after the Promise has resolved
    //    }));
    //}

    //getCoachDashboardInfo() {
    //    this.loading = true;
    //    this._CoachService.getCoachDashboardInfo().subscribe((data: any) => {
    //        console.log("response_GetCoachDashboardInfo", data);

    //        if (this._Globals.validationToken(data.result.Result)) {
    //            let _data = JSON.parse(data.result.Data);
    //            console.log('_data', _data);
    //            this.data = _data.Announcements;
    //            this.loading = false;
    //        }
    //    });
    //}

    getAdminAnnouncements() {
        this._AdminService.getAdminAnnouncements().subscribe((data: any) => {
            console.log("response_getAdminAnnouncements", data);

            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result === 1) {
                    let _data = JSON.parse(data.result.Data);
                    console.log('_data', _data);
                    this.data = _data;
                }
                else
                {
                    this._toastr.error('We are sorry. An unexpected error happened while trying to get the announcements', "ELI");
                }
                this.loading = false;
            }
        })
    }

    createHeaders() {
        let columnDefs = new Array();

        let announcementsHeader = {
            headerName: 'Text',
            field: 'Text',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(announcementsHeader);

        let expiresOnsHeader = {
            headerName: 'Expires on',
            field: 'ExpiresOn',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(expiresOnsHeader);

        let enabledHeader = {
            headerName: 'Enabled',
            field: 'Enabled',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {

                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + (params.value === true? 'Yes': 'No') + '</div>';
            }
        };
        columnDefs.push(enabledHeader);

        return columnDefs;
    }


    onRowSelected(event) {
        console.log("onRowSelected", event);
    }


    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }


    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            //this.editAnnouncement(data['Id'], data['Text']);
            this.getAnnouncement(data['Id']);
            //switch (e.event.target.id) {
            //    case "editAction":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.edit(data['Id']);
            //            break;
            //        }

            //    case "deleteAction":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.delete();
            //            break;
            //        }
            //}
        }
    }


    openModal() {
        $("#announcementModal").modal({ backdrop: "static" });
        $('#announcementModal').modal('show');
    }

    closeModal() {
        $('#area').val('');
        this.announcementId = 0;
        this.expiresOnDate = this.getTodayDate2();
        this.checkboxStatus = true;
        $('#announcementModal').modal('hide');
    }

    saveAnnouncement() {
        const text = $('#area').val();
        if (text === "") {
            this._toastr.warning('We are sorry. Please complete all fields', 'ELI');
            return;
        }

        // let expiredOn = $('.wc-date-container span').text();
        let expiredOn = $('#inputAnnouncementDatePicker').val();
        
        //this.scheduledDate = this.scheduledDate.slice(0, 10);
        const tempDate = expiredOn.split(" ");
        expiredOn = tempDate[0];
        expiredOn = expiredOn.replace(/-/g, "/");

        console.log('expiredOn', expiredOn);


        const today = new Date();
        const currentDate = new Date(expiredOn);
        currentDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        if (currentDate < today) {
            this._toastr.warning("Expiration date must be greater or equal than the current date.", "ELI");
            return;
        }


        this.creating = true;
        $('input, textarea').prop('disabled', true);
        $('#inputAnnouncementDatePicker').css('pointer-events', 'none');

        this._AdminService.postSaveAnnouncement(this.announcementId, text, expiredOn, this.checkboxStatus).subscribe((data: any) => {
            console.log('response_PostSaveQuestion', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result === 1)
                {
                    this._toastr.success("Announcement saved successfully.", "ELI");
                    //this.getCoachDashboardInfo();
                    this.getAdminAnnouncements();
                    this.closeModal();
                }
                else
                {
                    this._toastr.error("We are sorry.  An unexpected error happened while trying to save the announcement.", "ELI");
                }
                this.creating = false;
                $('input, textarea').prop('disabled', false);
                $('#inputAnnouncementDatePicker').css('pointer-events', 'all');
            } 
        });
    }

    getAnnouncement(announcementId) {
        this._AdminService.getAnnouncement(announcementId).subscribe((data: any) => {
            console.log('response_GetAnnouncement', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.announcementId = announcementId;
                $('#area').val(_data.Text);
                /*set the date*/
                this.checkboxStatus = _data.IsActive;
                this.expiresOnDate = this.getDate(new Date(_data.ExpiresOn));
                this.openModal();
            } 
        })
    }

    deleteAnnouncement() {
        this.deleting = true;
        this._AdminService.postDeleteAnnouncement(this.announcementId).subscribe((data: any) => {
            console.log('response_deleteAnnouncement', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result === 1) {
                    //this.getCoachDashboardInfo();
                    this.getAdminAnnouncements();
                    this.closeModalConfirmation();
                    this.closeModal();
                    this._toastr.success("Announcement deleted successfully.", "ELI");
                } else {
                    this._toastr.error("We are sorry.  An error happened while trying to delete the Announcement", "ELI");
                }
                this.deleting = false;
            }
        })
    }
    
    /*Confirmation Delete*/

    openConfirmationModal() {
        $("#confirmationDeleteModal").modal({ backdrop: "static" });
        $('#confirmationDeleteModal').modal('show');
    }

    closeModalConfirmation() {
        $('#confirmationDeleteModal').modal('hide');
    }


}

